export default {
    dict: {
        "000001": "上证指数",
        399001: "深证成指",
        399006: "创业板指",
        510050: "上证50ETF",
        510300: "沪深300ETF",
        159915: "创业板ETF",
        588000: "科创50ETF",
        510500: "中证500ETF",
        CN00Y: "富时A50指数",
    },
    // 公共组件
    widget: {
        underlying: {},
        ppl: {
            title: "期权分析专家",
            exclusive_privileges: "专属权益",

            cloud_storage: "多标的市场总览：实时追踪上证50、沪深300、科创50等核心标的的 OI、IV、Gamma、Max Pain。",
            historical_analysis: "智能异动监测：自动识别隔夜暴增、IV异常、仓差异动，并生成 AI 市场结构解读。",
            strategy_tools: " AI 市场智脑：每日自动生成市场结构报告，支持自然语言提问与策略分析。",
            research_reports: "波动率曲面与期限结构分析：深度呈现市场定价情绪与风险预期。",
            anomaly_monitoring: "合约与策略回测中心：多合约历史回测、策略敏感度分析与 AI 优化建议。",
            member_community: "从数据到洞察，从图表到结论，让 AI 帮你看懂期权市场。",

            // 声明
            disclaimer: "声明",
            disclaimer_1: "本产品为虚拟服务产品，购买后不支持退款。",
            disclaimer_2: "本产品不构成任何投资建议，所有内容仅供学习与研究参考。",
            purchase: "购买权益",
            year: "年",
            original: "原价",
        },
    },
    overview: {
        no_data: "该日期没有交易数据，可能为非交易日",
        news: {
            title: "消息哨兵",
            more: "更多",
        },
        long_short: {
            call: "认购成交/持仓量(张)",
            put: "认购成交/持仓量(张)",
        },
        mini_chart: {
            volatility_surface: "波动率曲面",
            distribution: "持仓分析",
            gamma_wall: "Gamma墙",
        },
        notice: {
            title: "通知",
            more: "详情",
        },
        helper: {
            title: "小贴士",
            helper_1: "波点：是FSF针对A股ETF期权的一个概念，1波点，用1°表示，对应0.001。",
            helper_2: "每日快照数据在收盘后陆续更新，部分数据可能延时至20点以后更新。",
        },
    },
    // 实时分析
    realtime: {
        underlying: {
            open_price: "今开",
            close_price: "昨收",
            high_price: "最高",
            low_price: "最低",
        },
        toolbar: {
            add: "添加T价看板",
            setting: "设置",
            sort: "排序",
            save: "保存",
            refresh: "刷新",
            seconds: "秒",
            auto_refresh: "自动刷新",
            target: "标的",
            target_placeholder: "请选择标的",
            expiration_date: "到期时间",
            expiration_date_placeholder: "请选择到期时间",
            duplicate: "该看板已存在，请选择其他标的或到期时间",
        },
        tboard: {
            settings_tip: "拖动调整字段顺序，勾选控制字段显示/隐藏",
            columns_settings: "字段设置",
            setting: "设置",
            days: "天",

            // 最新，涨跌幅，涨跌额，持仓量，成交量， 隐含波动率，行权价
            columns: {
                name: "名称",
                latest: "最新",
                change_rate: "涨跌幅",
                change_amount: "涨跌额",
                open_interest: "持仓量",
                volume: "成交量",
                implied_volatility: "隐含波动率",
                strike_price: "行权价",
                oi_change: "仓差",
                theta: "Theta",
                delta: "Delta",
                vega: "Vega",
                theoretical_price: "理论价",
            },

            settings: {
                title: "设置",
                column: "每行个数",
            },

            // 异动提示
            abnormal: {
                warning: "异动提醒",
                critical: "严重异动",
                change_rate: "涨跌幅",
                deviation: "偏离均值",
                sigma: "个标准差",
            },
            // 溢价
            premium_tip: {
                high: "当前价格高于理论价格，存在{price}元溢价",
                low: "当前价格低于理论价格，存在{price}元折价",
            },
        },
    },
    history: {
        tabs: {
            contract_stat: "标的合约趋势统计",
        },

        macroanalysis: "宏观分析",
        microanalysis: "微观分析",
        contract_trend: "合约趋势",
        underlying_trend: "标的趋势",

        // K线图相关
        kline: {
            open: "开盘",
            close: "收盘",
            high: "最高",
            low: "最低",
            amount: "成交额",
            avg: "平均值",
        },
        stock_stat: {
            fluctuation: "波点振幅",
            kline: "K线",
            fluctuation_points: "波动点数",
            positive: "正波点",
            negative: "负波点",
            point_max: "最大波点",
            point_min: "最小波点",
            stat: {
                positive_max: "正波点MAX",
                negative_max: "负波点MAX",
                positive_avg: "平均正波点",
                negative_avg: "平均负波点",
            },
            fluctuation_tip:
                "波点：用°作为单位，为本应用专门为中国期权设置。以当前ETF期权为例，1波点代表ETF价格波动0.001。",
            iv_history: "历史隐含波动率",
        },

        contract_stat: {
            date: "合约日期",
            code: "标的代码",
            name: "标的名称",
            contract_count: "合约数量",
            turnover_million_cny: "总成交额(万元)",
            volume: "总成交量(张)",
            call_volume: "认购成交量",
            put_volume: "认沽成交量",
            put_call_ratio_pct: "认购/认沽(%)",
            open_interest: "未平仓合约总数",
            call_open_interest: "未平仓认购合约数",
            put_open_interest: "未平仓认沽合约数",
            unit: "张",
            no_data: "当前时段无交易数据",
            total: "合计",
            volume_name: "成交量",
            interest_name: "持仓量",
            put_call_ratio_name: "PCR",
        },
        oi_trend: "持仓量",
        oi_trend_tip: "观察市场的多空倾向随时间的变化",
        volume_trend: "成交量",
        volume_trend_tip: "流动性与活跃度指标，成交量峰值日，往往对应行情转折或事件驱动",

        // 持仓合约分布
        contract_distribution: "合约分布",
        contract_distribution_title: "{mode}合约分布",
        expiration_date: "到期日",
        check_all: "全部",
        strike_price: "行权价",
        call: "看涨",
        put: "看跌",
        distribution_mode: {
            open_interest: "持仓量",
            oi_change: "仓差",
            volume: "成交量",
            turnover: "成交额",
        },

        // 排行榜
        rank: {
            title: "排行榜",
            all: "全部",
            position_increase: "增仓",
            position_decrease: "减仓",
            price_increase: "涨幅",
            price_decrease: "跌幅",
            open_interest: "持仓量榜",
            open_interest_tip: "看主力长期押注的重点执行价（趋势仓位）",
            volume: "成交量榜",
            volume_tip: "看当天资金「活跃操作」在哪些合约上",
            oi_change: "ΔOI 榜",
            oi_change_tip: "体现市场“兴趣点转移”",
            change_rate: "涨跌幅榜",
            change_rate_tip: "寻找热门合约",
            implied_volatility: "IV榜",
            implied_volatility_tip: "寻找短期溢价",
        },

        scatter: "成交热力图",
        volume_scatter: "成交量热力图",
        turnover_scatter: "成交额热力图",
        max_pain: "最大痛点",
        delta_weighted_oi: "Δ加权持仓量",
        dealer_gamma: "Gamma墙",
        expiration_month: "到期月份",

        gamma: {
            bias: "Bias值",
            structure_type: "结构类型",
            market_feature: "市场特征",
            structure_type_1: "压力主导（多Gamma）",
            market_feature_1: "做市商逆势对冲，波动被压制，震荡偏平",
            structure_type_2: "支撑主导（空Gamma）",
            market_feature_2: "做市商顺势对冲，波动被放大，行情易突破",
            structure_type_3: "中性结构",
            market_feature_3: "上下墙力量均衡，价格多震荡于中间区间",
            support_title: "支撑主导",
            pressure_title: "压力主导",
        },

        volatility: "波动率",
        term_structure: "波动率期限结构",
        strike_skew: "波动率微笑",
        comprehensive: "综合",
    },
    analyze: {
        toolbar: {
            contract: "标的",
            search_placeholder: "请输入标的代码或名称进行搜索",
            clear: "清空",
            title: "选择合约",
            empty: "< 点击选择合约 >",
            select_limit: "最多只能选择{num}个合约进行对比",
            select: "请选择",
            already_selected: "该合约已在选择列表中",
            add_disabled: "请先选择标的",
        },
        iv_chart_title: "历史隐含波动率",
        price_kline_chart_title: "价格走势",
        risk_indicators: "风险指标",
        fav: "收藏夹",
        empty_fav: "暂无收藏合约",
        empty_guide: "请先选择需要分析的合约",
        delete_confirm: "确定要删除该合约吗？",
        risk: {
            vega: "波动率IV每变化1%，期权价格变动{vega}元。",
            delta: "标的价格每变化1波点(0.001），期权价格变动{delta}元，期权行权概率约为{delta_pct}%。",
            theta: "时间每流逝1天，期权价格变动{theta}元。",
            rho: "无风险利率每变化1%，期权价格变动{rho}元，默认取1年期国债收益率，对短期合约影响较小。",
            gamma: "标的价格每变化1波点(0.001)，Delta 约变化{gamma}，平值且临近到期时通常最大。",
        },
        info: {
            days_to_expiry: "到期天数",
            iv: "隐含波动率",
            prev_close: "前收价",
            open_price: "开盘价",
            last_price: "收盘价",
            oi_change: "仓差",
            open_interest: "持仓量",
            overnight_gap: "开盘跳空",
            today_change: "T+0涨跌",
            days_to_expiry_tip:
                ">60 天：时间价值衰减相对平缓\n60～30 天：Theta 明显变大，ATM 日 Theta 约为 120 天附近的 1.3～1.5 倍\n30～7 天：进入“加速衰减期”，ATM 日 Theta 大致是 60 天时的 1.5～3 倍\n <7 天：进入“极速衰减期”，ATM 日 Theta 约为 30 天时的 2～3 倍\n<3 天：Theta 非线性放大，快速归零",
        },
    },
    calc: {
        title: "期权计算器",
        my_strategies: "我的策略",
        type: "类型",
        option_type: {
            call: "看涨期权",
            put: "看跌期权",
        },
        display: {
            theoretical_price: "期权理论价格",
            premium_rate: "溢价率",
        },
        greeks: {
            delta: "Delta",
            gamma: "Gamma",
            vega: "Vega",
            theta: "Theta",
            rho: "Rho",
        },
        metrics: {
            intrinsic_value: "内在价值",
            time_value: "时间价值",
            seller_annualized: "卖方年化",
        },
        params: {
            title: "输入参数",
            underlying: "标的选择",
            underlying_placeholder: "选择标的",
            spot_price: "标的价格 (S)",
            strike_price: "行权价格 (K)",
            volatility: "波动率 (σ)",
            expiry_date: "到期日期",
            expiry_date_placeholder: "选择到期日期",
            days_remaining: "剩余 {days} 天到期",
            risk_free_rate: "无风险利率 (r)",
        },
        strategy: {
            title: "策略推导",
            empty: "请输入参数并计算",
            annualized: {
                title: "年化收益策略",
                days: "到期天数",
                days_unit: "天",
                margin: "保证金要求（元/张，仅卖方）",
                profit: "权利金收益（元/张）",
                rate: "年化收益率",
            },
            t0: {
                title: "T+0策略收益",
                profit: "预计盈亏",
                volatility: {
                    title: "Vega 波动收益",
                    change: "波动率变化",
                },
                delta: {
                    title: "Delta 价格收益",
                    change: "标的价格变化",
                },
                theta: {
                    title: "Theta 时间收益",
                    days: "时间衰减",
                },
            },
        },
        strategy_list: {
            title: "策略列表",
            underlying_code: "标的代码",
            underlying_code_placeholder: "输入标的代码",
            option_type: "期权类型",
            option_type_placeholder: "选择类型",
            expiry_date: "到期日期",
            parameters: "计算参数",
            results: "计算结果",
            load: "加载",
            load_failed: "加载策略列表失败",
            delete_confirm: "确定删除该策略吗？",
            price: "价格",
        },
        decay: {
            title: "时间价值衰减曲线",
            current: "当前",
            days: "天",
            remaining_days: "剩余 {day} 天",
            call_time_value: "看涨期权时间价值",
            put_time_value: "看跌期权时间价值",
            call_decay_percent: "看涨衰减百分比",
            put_decay_percent: "看跌衰减百分比",
            days_remaining: "剩余天数",
            time_value: "时间价值 (元)",
            decay_percent: "衰减百分比 (%)",
        },
    },
    trade: {
        prev: "前一日",
        latest: "最新交易日",
        next: "后一日",
        date_placeholder: "请选择日期",
    },
    underlying: {
        latest_price: "最新",
        open_price: "今开",
        close_price: "昨收",
        high_price: "最高",
        low_price: "最低",
        avg_price: "平均",
        amplitude: "振幅",
        change_amount: "涨跌额",
        change_rate: "涨跌幅",
        iv_index: "隐含波动率指数",
        volume: "成交量",
        amount: "成交额",
        volume_ratio: "量比",
        buy_volume: "外盘",
        sell_volume: "内盘",
        sentiment_index: "情绪指数",
        sentiment_extreme_bullish: "极度看涨",
        sentiment_extreme_bearish: "极度看跌",
        sentiment_mild_bullish: "轻微偏多",
        sentiment_mild_bearish: "轻微偏空",
        sentiment_neutral: "中性平衡",
        total_oi: "总持仓量",
        max_pain: "推测最大痛点",
        open: "开盘",
        close: "前结",
    },
};
